module.exports = __webpack_public_path__ + "media/images/mobile/solutions/explr-bg5-29822766431dba06c223b80c76bd3a05.png";